export const DrinkItems = [
  {
    title: 'Wiener Melange',
    text: 'A Wiener Melange is a speciality coffee drink similar to a cappuccino.',
    price: '2,50',
    img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/1/1e/Wiener_Melange_0363wien_img_9691.jpg/220px-Wiener_Melange_0363wien_img_9691.jpg',
  },
  {
    title: 'Cappuccino',
    text: 'A cappuccino is an espresso-based coffee drink is popularized in Italy and prepared with steamed milk foam',
    price: '3,25',
    img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/c8/Cappuccino_at_Sightglass_Coffee.jpg/220px-Cappuccino_at_Sightglass_Coffee.jpg',
  },
  {
    title: 'Masala Chai',
    text: 'Masala chai is an Indian tea beverage made by boiling black tea in milk and mixture of aromatic herbs.',
    price: '4,00',
    img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/04/Masala_Chai.JPG/220px-Masala_Chai.JPG',
  },
  {
    title: 'Mocaccino',
    text: 'Mocaccino is a chocolate-flavoured warm beverage commonly served in a glass rather than a mug.',
    price: '3,75',
    img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/7e/Mocha_coffee.jpg/250px-Mocha_coffee.jpg',
  },
  {
    title: 'Espresso',
    text: 'Espresso is a coffee-brewing method of Italian origin.',
    price: '3,00',
    img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Tazzina_di_caff%C3%A8_a_Ventimiglia.jpg/220px-Tazzina_di_caff%C3%A8_a_Ventimiglia.jpg',
  },
  {
    title: 'Hot Chocolate',
    text: 'Hot chocolate, also known as hot cocoa or drinking chocolate, is a heated drink consisting of shaved chocolate.',
    price: '5,25',
    img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Hei%C3%9Fe_Schokolade.jpg/220px-Hei%C3%9Fe_Schokolade.jpg',
  },
  {
    title: 'Caffè Americano',
    text: 'Caffè Americano is a type of coffee drink prepared by diluting an espresso with hot water, giving it a similar strength to, but different flavor from, traditionally brewed coffee.',
    price: '4,75',
    img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Hokitika_Cheese_and_Deli%2C_Hokitika_%283526706594%29.jpg/250px-Hokitika_Cheese_and_Deli%2C_Hokitika_%283526706594%29.jpg',
  },
  {
    title: 'Lemonade',
    text: 'Lemonade is a sweetened lemon-flavored beverage.',
    price: '2,00',
    img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/ca/R_Whites_lemonade_%282%29.JPG/161px-R_Whites_lemonade_%282%29.JPG',
  },
  {
    title: 'Caffè Macchiato',
    text: 'Caffè macchiato is an espresso coffee drink with a small amount of milk, usually foamed.',
    price: '3,50',
    img: 'https://images.pexels.com/photos/350478/pexels-photo-350478.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  },
  {
    title: 'Cocktail Special',
    text: 'Cocktails are either a combination of spirits, or one or more spirits mixed with other ingredients such as tonic water, fruit juice, flavored syrup, or cream. ',
    price: '7.25',
    img: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/80/15-09-26-RalfR-WLC-0084.jpg/240px-15-09-26-RalfR-WLC-0084.jpg',
  },
];
